import '@byted-bricks/ppl-modal/styles/scale.global.css';

import AppContainer from './Container';
import bootstrap from '~/common/bootstrap';

export default bootstrap(AppContainer);
